/** Barevné tokeny tématu (viz ThemeService::COLOR_KEYS). */
export const THEME_COLOR_KEYS = [
  'primary', 'secondary', 'accent', 'success', 'warning', 'danger', 'info',
  'bg', 'surface', 'text', 'textMuted', 'border',
  'navbarBg', 'navbarText',
] as const;
export type ThemeColorKey = typeof THEME_COLOR_KEYS[number];

export type ThemeColorMode = 'light' | 'dark' | 'system';

export type ThemeSettings = {
  colors: {
    light: Record<ThemeColorKey, string>;
    /** null = odvodí se automaticky ze světlé palety */
    dark: Record<ThemeColorKey, string | null>;
  };
  defaultColorMode: ThemeColorMode;
  fonts: { body: string; heading: string };
  /** v %, 60–140 */
  density: number;
  backgroundPattern: boolean;
};

export type ThemePublicDto = {
  /** null = výchozí téma, které není uložené v DB */
  id: number | null;
  name: string;
  settings: ThemeSettings;
  logoLightUrl: string | null;
  logoDarkUrl: string | null;
  isActive: boolean;
  /** uživatel si ho může vybrat v osobním přizpůsobení vzhledu */
  userSelectable: boolean;
};

export type ThemeSaveDto = { id: number | null; name: string | null; settings: ThemeSettings | null; userSelectable: boolean };

export type ThemeOptionsDto = {
  fonts: string[];
  densityMin: number;
  densityMax: number;
  fontScaleMin: number;
  fontScaleMax: number;
  logoMaxBytes: number;
  logoMimes: string[];
  defaultSettings: ThemeSettings;
};

/** Osobní přizpůsobení vzhledu; null = hodnota z (vybraného) tématu. */
export type UserAppearanceDto = {
  themeId: number | null;
  /** kompaktnost v % */
  density: number | null;
  /** velikost písma v % */
  fontScale: number | null;
  colorMode: ThemeColorMode | null;
};

/** Rozsahy osobního nastavení (v %) — shodné s ThemeService::DENSITY_* / FONT_SCALE_*, server je hlídá. */
export const APPEARANCE_LIMITS = {
  density: { min: 60, max: 140 },
  fontScale: { min: 70, max: 130 },
} as const;
